import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=f604704c&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=f604704c&prod&scoped=true&lang=css"
import style1 from "./CustomerService.vue?vue&type=style&index=1&id=f604704c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f604704c",
  null
  
)

export default component.exports